import React, { useState, useEffect } from 'react';
import './EstatesSection.css';

const EstatesSection = () => {
  const estates = [
    {
      name: 'White House Estate Kuje Phase 3',
      location: 'Kuje, Abuja, Nigeria',
      description: 'A premier estate development in Kuje featuring modern infrastructure, green spaces, and cutting-edge technology. Located in Abuja with easy access to major landmarks.',
      features: [
        'Green Estate',
        'Smart Estate',
        'Central Sewage System',
        'Good Road Community',
        'Gated Security',
        'Treated Water',
        '24/7 Power',
        'Play Area',
        'Gym'
      ],
      title: 'R OF O (Right of Occupancy)',
      plotSize: '400 SQM',
      image: '/images/whitehouse_abuja.jpg'
    },
    {
      name: 'White House Gardens Estate Atan',
      location: 'Atan, Ota, Ogun State, Nigeria',
      description: 'A premier estate development in Atan featuring modern infrastructure, smart technology integration, and premium amenities for modern living.',
      features: [
        'Green Estate',
        'Smart Estate',
        'Central Sewage System',
        'Good Road Community',
        'Gated Security',
        'Treated Water',
        '24/7 Power',
        'Play Area',
        'Gym'
      ],
      title: 'DEED OF ASSIGNMENT',
      plotSize: '400 SQM',
      image: '/images/whitehouse_ogun.jpg'
    },
    {
      name: 'White House Polo & Golf Moniya',
      location: 'Moniya, Ibadan, Oyo State, Nigeria',
      description: 'A premier estate development in Moniya featuring modern infrastructure, smart technology integration, and premium amenities. Strategically located near key transportation hubs.',
      features: [
        'Green Estate',
        'Smart Estate',
        'Central Sewage System',
        'Good Road Community',
        'Gated Security',
        'Security',
        'Treated Water',
        '24/7 Power',
        'Play Area',
        'Gym'
      ],
      title: 'C OF O (Certificate of Occupancy)',
      plotSize: '400 SQM',
      image: '/images/whitehouse_oyo.jpg'
    }
  ];

  return (
    <section id="estates" className="estates-section section">
      <div className="container">
        <h2 className="section-title">Our Estates</h2>
        <p className="section-subtitle">
          Explore our premium real estate developments across prime locations
        </p>
        
        <div className="estates-grid">
          {estates.map((estate, index) => (
            <div key={index} className="estate-card card">
              {estate.images && estate.images.length > 0 ? (
                <EstateImageSlider images={estate.images} estateName={estate.name} />
              ) : estate.image ? (
                <div className="estate-image-container">
                  <img 
                    src={estate.image} 
                    alt={estate.name}
                    className="estate-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              ) : null}
              <div className="estate-header">
                <h3 className="estate-name">{estate.name}</h3>
                <p className="estate-location">
                  <span className="location-icon">📍</span> {estate.location}
                </p>
              </div>
              
              <p className="estate-description">{estate.description}</p>
              
              <div className="estate-details">
                <div className="detail-item">
                  <strong>Title:</strong> {estate.title}
                </div>
                <div className="detail-item">
                  <strong>Plot Size:</strong> {estate.plotSize}
                </div>
              </div>
              
              <div className="estate-features">
                <h4>Key Features:</h4>
                <ul className="features-list">
                  {estate.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Image Slider Component for estates with multiple images
const EstateImageSlider = ({ images, estateName }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageErrors, setImageErrors] = useState({});

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  // Handle image load errors
  const handleImageError = (index) => {
    setImageErrors((prev) => ({ ...prev, [index]: true }));
  };

  // Filter out images that failed to load
  const validImages = images.filter((_, index) => !imageErrors[index]);

  // If no valid images, show gradient background
  if (validImages.length === 0) {
    return <div className="estate-image-container" />;
  }

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? validImages.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === validImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="estate-image-slider">
      <div className="slider-container">
        {validImages.map((image, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? 'active' : ''}`}
          >
            <img
              src={image}
              alt={`${estateName} - Image ${index + 1}`}
              className="estate-image"
              onError={() => handleImageError(index)}
            />
          </div>
        ))}
        
        {/* Navigation arrows */}
        {validImages.length > 1 && (
          <>
            <button 
              className="slider-arrow slider-arrow-left" 
              onClick={goToPrevious}
              aria-label="Previous image"
            >
              ‹
            </button>
            <button 
              className="slider-arrow slider-arrow-right" 
              onClick={goToNext}
              aria-label="Next image"
            >
              ›
            </button>
          </>
        )}
      </div>
      
      {/* Dots indicator */}
      {validImages.length > 1 && (
        <div className="slider-dots">
          {validImages.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EstatesSection;

